import { CIcon } from '~/icons/types'

export const ciHouseGarden: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.5 11a1.915 1.915 0 0 0-1.739-1.991V9a4.267 4.267 0 0 0-3.979-4.5H7.218A4.267 4.267 0 0 0 3.239 9v.01A1.915 1.915 0 0 0 1.5 11v4a2.455 2.455 0 0 0 1.739 2.431V19a.5.5 0 0 0 1 0v-1.5h15.522V19a.5.5 0 1 0 1 0v-1.567A2.456 2.456 0 0 0 22.5 15v-4Zm-10-5.5h4.282A3.274 3.274 0 0 1 19.761 9v.3a2.049 2.049 0 0 0-.869 1.7v1c0 .271-.169.5-.37.5H12.5v-7ZM4.239 9a3.274 3.274 0 0 1 2.979-3.5H11.5v7H5.478c-.2 0-.37-.228-.37-.5v-1a2.045 2.045 0 0 0-.869-1.7V9ZM21.5 11v4a1.393 1.393 0 0 1-1.224 1.5H3.724A1.393 1.393 0 0 1 2.5 15v-4a.92.92 0 0 1 .805-1 .92.92 0 0 1 .8 1v1a1.44 1.44 0 0 0 1.37 1.5h13.046a1.44 1.44 0 0 0 1.37-1.5v-1a.919.919 0 0 1 .8-1 .919.919 0 0 1 .8 1h.009Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'house-garden',
  type: 'thin'
}
